export default __webpack_public_path__ + "static/media/330_dummy2016-restaurant03-mobile-de.c5e171ea.png";